import styled from 'styled-components';

export interface IPaperContainerProps {
  gridTemplateColumns?: string;
  gridColumn?: string;
}

export const PaperContainer = styled.div<IPaperContainerProps>`
  height: 100%;
  border-radius: 8px !important;
  display: flex;
  background: #fff;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    padding: 0 15px;
  }
`;
